import { useEffect, useState } from "react";
import { featureEnv } from "../featureEnv";
export const useFlags = () => {
    const [flags, setFlags] = useState(featureEnv.getFlags() || {});
    useEffect(() => {
        featureEnv
            .subscribe(() => {
            setFlags(featureEnv.getFlags.bind(featureEnv));
        })
            .bind(featureEnv);
    }, [setFlags]);
    if (Object.keys(flags).length === 0) {
        return undefined;
    }
    return flags;
};
//# sourceMappingURL=useFlags.js.map